import { render } from "./CategoryStatsCard.vue?vue&type=template&id=0a144486&scoped=true"
import script from "./CategoryStatsCard.vue?vue&type=script&lang=js"
export * from "./CategoryStatsCard.vue?vue&type=script&lang=js"

import "./CategoryStatsCard.vue?vue&type=style&index=0&id=0a144486&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a144486"]])

export default __exports__